import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/fda";

export default function Callbacks() {
  const [rows, setRows] = useState([]);
  const [agents, setAgents] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/callbacks");
    setRows(data);
  }, []);

  useEffect(() => { load(); api.get("/agents").then(({ data }) => setAgents(data)).catch(() => {}); }, [load]);

  const update = async (id, patch, msg) => {
    try { await api.patch(`/callbacks/${id}`, patch); toast.success(msg); load(); }
    catch { toast.error("Action failed"); }
  };

  return (
    <div data-testid="admin-callbacks-page">
      <h1 className="font-display text-3xl font-extrabold text-forest">Callbacks</h1>
      <p className="mt-2 text-sm text-forest-soft">A callback is a task reminder. It is not proof that a call took place.</p>
      <div className="mt-6 overflow-x-auto rounded-2xl border border-border bg-white">
        <table className="w-full min-w-[1000px] text-left text-sm">
          <thead className="bg-sand-deep text-xs font-bold uppercase tracking-wider text-forest-soft">
            <tr>{["Customer", "Reference", "Phone", "Date", "Time", "Agent", "Status", "Notes", "Actions"].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={9} className="px-4 py-10 text-center text-forest-soft" data-testid="callbacks-empty">No callbacks scheduled.</td></tr>}
            {rows.map((c) => {
              const dt = new Date(c.callback_at);
              return (
                <tr key={c.id} className="border-t border-border" data-testid={`callback-row-${c.lead_reference}`}>
                  <td className="px-4 py-3 font-semibold text-forest">{c.customer}</td>
                  <td className="px-4 py-3"><Link to={`/admin/leads/${c.lead_id}`} className="font-bold text-terracotta underline">{c.lead_reference}</Link></td>
                  <td className="px-4 py-3">{c.phone}</td>
                  <td className="px-4 py-3">{dt.toLocaleDateString("en-GB")}</td>
                  <td className="px-4 py-3">{dt.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</td>
                  <td className="px-4 py-3 text-xs">{agents.find((a) => a.id === c.agent_id)?.name || "—"}</td>
                  <td className="px-4 py-3"><span className="rounded bg-forest px-2 py-1 text-[10px] font-bold text-sand">{c.status}</span></td>
                  <td className="px-4 py-3 text-xs text-forest-soft">{c.notes || "—"}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-wrap gap-2">
                      <a href={`tel:${c.phone}`} data-testid={`callback-call-${c.lead_reference}`} className="rounded-full bg-forest px-3 py-1.5 text-[10px] font-bold uppercase text-sand">Call</a>
                      <button data-testid={`callback-complete-${c.lead_reference}`} onClick={() => update(c.id, { status: "COMPLETED" }, "Callback completed")} className="rounded-full bg-moss px-3 py-1.5 text-[10px] font-bold uppercase text-white">Complete</button>
                      <button data-testid={`callback-reschedule-${c.lead_reference}`} onClick={() => {
                        const v = window.prompt("New date & time (YYYY-MM-DD HH:MM)");
                        if (v) update(c.id, { callback_at: new Date(v.replace(" ", "T")).toISOString(), status: "PENDING" }, "Callback rescheduled");
                      }} className="rounded-full border-2 border-border px-3 py-1.5 text-[10px] font-bold uppercase text-forest">Reschedule</button>
                      <button data-testid={`callback-cancel-${c.lead_reference}`} onClick={() => update(c.id, { status: "CANCELLED" }, "Callback cancelled")} className="rounded-full border-2 border-destructive px-3 py-1.5 text-[10px] font-bold uppercase text-destructive">Cancel</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
